import { styled, Stack, type StackProps } from '@mui/material'
import { ComponentType } from 'react'

type BulkFieldRootProps = StackProps

export const BulkFieldRoot = styled(Stack, {
  name: 'BulkFieldRoot',
})<BulkFieldRootProps>(({ theme: { spacing } }) => ({
  width: '100%',
  gap: spacing(2),
})) as ComponentType<BulkFieldRootProps>
